module.exports = __webpack_public_path__ + "img/uc2.eef5b52f.png";